export const styles = {
  badgeRow: {
    display: 'flex',
    gap: 0.75,
    flexWrap: 'wrap',
    mt: 0.5,
  },
  chip: (bgcolor: string, color: string) => ({
    height: 22,
    fontSize: '0.7rem',
    fontWeight: 600,
    backgroundColor: bgcolor,
    color,
    cursor: 'default',
  }),
}
